import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Setting = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      fill={fill}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M15.135 6.784c-1.303-.326-1.921-1.818-1.23-2.969.322-.536.225-.998-.094-1.316l-.31-.31c-.318-.318-.78-.415-1.316-.094-1.152.691-2.644.073-2.969-1.23C9.065.258 8.669 0 8.219 0h-.438c-.45 0-.845.258-.997.865-.326 1.303-1.818 1.921-2.969 1.23-.536-.322-.999-.225-1.317.093l-.31.31c-.318.318-.415.781-.093 1.317.691 1.152.073 2.644-1.23 2.969C.26 6.935 0 7.33 0 7.781v.438c0 .45.258.845.865.997 1.303.326 1.921 1.818 1.23 2.969-.322.536-.225.998.094 1.316l.31.31c.319.319.782.415 1.316.094 1.152-.691 2.644-.073 2.969 1.23.151.607.547.865.997.865h.438c.45 0 .845-.258.997-.865.326-1.303 1.818-1.921 2.969-1.23.535.321.997.225 1.316-.094l.31-.31c.318-.318.415-.78.094-1.316-.691-1.152-.073-2.644 1.23-2.969.607-.151.865-.547.865-.997v-.438c0-.451-.26-.846-.865-.997zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
        transform="translate(-1548 -1035) translate(1548 1035)"
      />
    </svg>
  );
};

Setting.displayName = 'Setting';
